import React, { useMemo } from "react";

// Subtle animated trading-chart backdrop. Decorative only.
function ChartBackdrop({ className = "", opacity = 0.16 }) {
  const paths = useMemo(() => {
    const make = (seed, base) => {
      let d = `M0 ${base}`;
      let y = base;
      for (let x = 60; x <= 1200; x += 60) {
        y += (Math.sin((x + seed) / 90) * 26) + (Math.random() - 0.5) * 18;
        y = Math.max(30, Math.min(360, y));
        d += ` L${x} ${y.toFixed(1)}`;
      }
      return d;
    };
    return [make(0, 240), make(400, 180), make(800, 300)];
  }, []);

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      style={{ opacity, transform: "translateZ(0)", willChange: "transform" }}
      aria-hidden
    >
      <svg viewBox="0 0 1200 400" preserveAspectRatio="none" className="h-full w-full">
        <defs>
          <linearGradient id="cbLine" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#6b7075" />
            <stop offset="55%" stopColor="#e8ebee" />
            <stop offset="100%" stopColor="#6b7075" />
          </linearGradient>
        </defs>
        {/* grid */}
        {Array.from({ length: 12 }).map((_, i) => (
          <line key={`v${i}`} x1={i * 100} y1="0" x2={i * 100} y2="400" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        ))}
        {Array.from({ length: 5 }).map((_, i) => (
          <line key={`h${i}`} x1="0" y1={i * 100} x2="1200" y2={i * 100} stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        ))}
        {paths.map((d, i) => (
          <path key={i} d={d} fill="none" stroke="url(#cbLine)" strokeWidth={i === 0 ? 2 : 1.2}
            className="chart-line" style={{ animationDelay: `${i * -6}s`, opacity: i === 0 ? 0.9 : 0.4 }} />
        ))}
      </svg>
      {/* scan beam */}
      <div className="scan-beam absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-transparent via-white/8 to-transparent" />
    </div>
  );
}

export default React.memo(ChartBackdrop);
